import axios from "axios";
import { getToken, removeToken } from "../ auth";

const apiBackUrl = process.env.REACT_APP_API_BACK;
const api = axios.create({
  baseURL: apiBackUrl,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Intercepteur de réponse pour gérer les erreurs d'authentification
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Ne pas intercepter les erreurs 401 de la route de login elle-même
      // (c'est normal qu'une tentative de connexion échoue avec 401)
      const requestUrl = error.config?.url || "";
      const isLoginRequest = requestUrl.includes("/auth/login");
      
      if (!isLoginRequest) {
        // Token expiré ou invalide pour une autre route
        removeToken();
        // Rediriger vers la page de connexion seulement si on n'est pas déjà sur /login ou /
        if (window.location.pathname !== "/login" && window.location.pathname !== "/") {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
